module.exports = __webpack_public_path__ + "static/logo-white-000333ac64a302c0a4e9a4cadfb43f38.png";